import { Product } from "../../types/types";

export type OwnBrand =
  | "jl_own_brand_anyday_legacy"
  | "jl_own_brand_anyday"
  | "jl_own_brand_john_lewis_legacy"
  | "jl_own_brand_john_lewis"
  | "";

export function getOwnBrand(product: Product): OwnBrand {
  const brandName = product.brand?.name;

  if (brandName === "ANYDAY John Lewis & Partners") {
    return "jl_own_brand_anyday_legacy";
  }
  if (brandName === "John Lewis ANYDAY") {
    return "jl_own_brand_anyday";
  }
  if (brandName === "John Lewis & Partners") {
    return "jl_own_brand_john_lewis_legacy";
  }
  if (brandName === "John Lewis") {
    return "jl_own_brand_john_lewis";
  }
  return "";
}
